const formatCampo = (value) => {
  const modalidades = {
    administracion: "Administración",
    ciencias_naturales_matematicas_y_estadistica: "Ciencias Naturales, Matemáticas y Estadística",
    salud_y_bienestar: "Salud y Bienestar",
    ingenieria_industria_y_construccion:"Ingeniería, Industria y Construcción",
    administracion_de_empresa_s:"Administración de Empresas y Derecho",
    educacion_comercial_y_administracion:"Educación Comercial y Administración",
   ciencias_sociales_periodismo_informacion_y_derecho: "Ciencias Sociales, Periodismo, Información y Derecho",
  };

  if (modalidades[value]) return modalidades[value];

  // fallback automático
  return value
    ?.replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};

const Campo = ({ value }) => {
  if (!value) return null;

  return (
    <>
     {formatCampo(value)}
    </>
  );
};

export default Campo;